import { Modal, Grid, Segment, Button } from 'component/base'
import { Custom } from 'component/pieces'

export const ShowImageModal = ({ imageId, onClose }) => {
  return (
    <Modal
      dimmer='inverted'
      open={!!imageId}
      closeOnEscape
      closeOnDimmerClick
      size='large'
      onClose={onClose}
    >
      <Modal.Content scrolling>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <Segment attached='bottom' textAlign='center'>
                {imageId && (
                  <Custom.Image.UploadImage
                    id={imageId}
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      objectFit: 'contain'
                    }}
                  />
                )}
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onClose} content='閉じる' />
      </Modal.Actions>
    </Modal>
  )
}